import { findIndex } from 'lodash/fp';

const getWizardStep = ({ wizard, url, next = true }) => {
    const { items } = wizard;
    const current = url.split('/').slice(-2).join('/');
    const currentIndex = findIndex(({ target }) => target === current, items);

    const jump = next ? 1 : -1;
    const targetIndex = currentIndex + jump;

    // Vérifier si l'index cible est valide
    if (targetIndex < 0 || targetIndex >= items.length || !items[targetIndex]) {
        return null;
    }

    return items[targetIndex].target;
};

export default getWizardStep;
